/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VideoPlayerComponent } from './components/video-player/video-player.component';

@NgModule({
  declarations: [VideoPlayerComponent],
  exports: [VideoPlayerComponent],
  imports: [CommonModule],
})
export class VideoPlayerModule {}
